module.exports = __webpack_public_path__ + "img/any-mask10.1ebe4d34.png";